const Alert = ({alert}) => {
    return (
      <div className={`${alert.error ? 'alert alert-danger' : 'alert alert-success'}`} role="alert">
          {alert.msg}
      </div>
    )
  }

  export default Alert